import { API_ENDPOINTS } from '../constants'
import ApiService from './apiService'
import http from './http'

export default {
  async load() {
    const url = ApiService.buildUrl(API_ENDPOINTS.settings)
    let { data } = await http.get(url)

    return data
  }
}
